import { gql } from '@apollo/client';

export const GET_CUSTOMER_USER_DATA = gql`
    query GetCustomerUserData {
        getCustomerUserData {
            division
            position
            name
            email
        }
    }
`;
